module.exports = __webpack_public_path__ + "img/arrow-right.12a68ba4.svg";